export default {"src":"/_next/static/media/alert.cce1f47a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};